import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PopupService {

  private popupDataSource = new Subject<any>();
  popupData$ = this.popupDataSource.asObservable();

  openPopup(record: any) {
    this.popupDataSource.next(record);
  }

  closePopup() {
    this.popupDataSource.next(null);
  }
}
